import Rails from "@rails/ujs";
import * as bootstrap from "bootstrap";
import jquery from "jquery";
import Swal from "sweetalert2/dist/sweetalert2.js";
// import { createPopper } from '@popperjs/core';
// import "../admin/libs/popper";

import "chartkick/chart.js";

window.bootstrap = bootstrap;
window.jQuery = jquery;
window.$ = jquery;
window.Swal = Swal;

import "./address";
import "./bs_popover";
import "./bs_tooltip";
import "./changeCaseFields";
import "./cocoon";
import "./fancybox";
import "./list";
import "./pnotify";
import "./showcase_timer";
import "./sweetalert";

// import initVmasker from "./vmasker";

Rails.start();
